import { object } from "../../helpers/object";
import { debug } from "../../helpers/debug";
import { utils } from "../../helpers/utils";
import { dialog } from "../../components/dialog";
import { mask } from "../../components/mask";
import { services } from "../../helpers/service";
import { strings } from "../../helpers/strings";
import { importLib } from "../../helpers/async-libs";

/*------------------------------------*\
  #FORMS AUTOFILL

  Class gestion des multiple formulaires
  avec un bloc permettant de sélectionner
  un formulaire à afficher

\*------------------------------------*/
class FormAutofill {

  constructor(module){
    this.MODULE = module;
    this.DOM_MODULE = object.toArray(document.querySelectorAll(this.MODULE));
    this.delay = 50;

  }
  /**
   * INITIALISATION
   * @returns 
   */
  init = () => {
    if (!this.DOM_MODULE.length) return;

    this.onload();

    if(debug.DEBUG) console.log('async/form/form-autofill.js');
  }
  onload = () => {
    setTimeout(() => {
      mask.display = true;
      const title = dialog.get('popin-loading', '.c-loader__label');
      if (title) title.innerHTML = 'Le formulaire est en cours de chargement...';
      dialog.open('popin-loading');
      this.getData();
    }, 1000);
  }

  /**
   * Handles the service type by prefilling form elements with data from a service.
   *
   * @param {HTMLElement} element - The form element that contains the input and textarea elements to be filled.
   * @returns {void}
   *
   * @example
   * // Assuming `element` is a form element containing input and textarea elements
   * handleServiceType(element);
   *
   * @description
   * This function uses the 'prefilling' service to retrieve data and populate the input and textarea elements
   * within the provided form element. It handles both radio inputs and text inputs/textarea elements.
   * If the service call fails, it logs the error to the console and closes the 'popin-loading' dialog.
   */
  handleServiceType = (element) => {
    const params = ((window.location.search.substring(1)));
    const service = element.getAttribute('data-js-form-autofill-service') ?? 'prefilling';
    services.use(service, params).then((result) => {

      if (!result?.datas?.elements) return;

      result.datas.elements.forEach((obj) => {
        Object.entries(obj).forEach(([entry, value]) => {
          const input = element.querySelector(`input[name="${entry}"]`);
          const textarea = element.querySelector(`textarea[name="${entry}"]`);

          if (input) {
            if (input.getAttribute('type') === 'radio') {
              input.checked = true;
            } else {
              input.value = value;
            }
          } else if (textarea) {
            textarea.value = value;
          }
        });
      });
    }).catch((error) => {
      console.error('service prefilling : ', error);
    }).finally(() => {
      dialog.close('popin-loading');
    });
  };
  /**
   * Handles the autofill of form inputs based on URL parameters.
   *
   * This function selects all elements with the attribute `data-js-autofill-type` within the given element,
   * retrieves the corresponding URL parameter value, and sets the input value if it matches the specified criteria.
   *
   * @param {HTMLElement} element - The DOM element containing the inputs to be autofilled.
   */
  handleUrlType = (element) => {
    element.querySelectorAll('[data-js-autofill-type]').forEach((input) => {
      const type = input.getAttribute('data-js-autofill-type');
      const parameter = input.getAttribute('data-js-autofill-parameter');
      const value = utils.getUrlParameter(parameter);
      importLib('form/modules/controls.js').then((control) => {
        if ((type === 'reference' && strings.isNumeric(value) && value.length === 8 && value !== "00000000") ||
            (type === 'email' && control.isEmail(value))) {
          input.value = value;
        }
      });

    });
    dialog.close('popin-loading');
  };
  /**
   * Retrieves data from DOM elements with the attribute 'data-js-form-autofill' and processes them based on their type.
   * Iterates over each element in the `this.DOM_MODULE` array and calls the appropriate handler function
   * based on the value of the 'data-js-form-autofill' attribute.
   *
   * @function
   * @name getData
   * @memberof FormAutofill
   */
  getData = () => {
    this.DOM_MODULE.forEach((element) => {
      const type = element.getAttribute('data-js-form-autofill');

      if (type === 'service') {
        this.handleServiceType(element);
      } else if (type === 'url') {
        this.handleUrlType(element);
      }
    });
  }
}
export default new FormAutofill('[data-js-form-autofill]'); 